import React, { ReactNode } from "react";

import { EmptyContainer } from "src/components/emptyContainer";

interface ErrorBoundaryProps {
  readonly message?: string;
  // Change this to reset the error and show the children again.
  readonly resetKey?: string;
  readonly children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  resetKey?: string;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, resetKey: props.resetKey };
  }

  static getDerivedStateFromError(): Partial<ErrorBoundaryState> {
    return { hasError: true };
  }

  static getDerivedStateFromProps(
    props: ErrorBoundaryProps,
    state: ErrorBoundaryState
  ): Partial<ErrorBoundaryState> | null {
    if (props.resetKey !== state.resetKey) {
      return { hasError: false, resetKey: props.resetKey };
    }
    return null;
  }

  render() {
    if (this.state.hasError) {
      return <EmptyContainer text={this.props.message || "Page not found."} />;
    }
    return this.props.children;
  }
}
